import { createApp } from 'vue';
import sidecart from '../../../vue/sidecart/sidecart.vue';

if (document.getElementById('vue-sidecart')) {
  const props = {

  };
  //we can save the return from the mount in order to call functions from outside the controller
  // i.e -> sidecart.open();
  const sideCartApp = createApp(sidecart, props);
  const vueSideCart = sideCartApp.mount('#vue-sidecart');
  window.vueSideCart = vueSideCart;
}
